// @flow
export const ACTION_TYPE_CLEAR_STATE = 'ACTION_TYPE_CLEAR_STATE';

type ClearStateAction = {|
  type: 'ACTION_TYPE_CLEAR_STATE',
|};

export const clearStateAction = {
  type: ACTION_TYPE_CLEAR_STATE,
};

export type Action = ClearStateAction;



// WEBPACK FOOTER //
// ./src/state/types/globalTypes.js